var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("App Rating")]),_vm._l((_vm.examples),function(example,index){return _c('s-g-usage',{key:index,attrs:{"headline":example.headline,"code":example.template,"inverted":true}},[_c(example,{tag:"component"})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }